import tw, { styled } from 'twin.macro';
import { keyframes } from 'styled-components';

const cardFadeIn = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const ManualEntryPromptWrapper = styled.div`
  ${tw`flex flex-col items-center gap-1 w-full`}
`;

export const ManualEntryPromptText = styled.p`
  ${tw`text-center text-sm w-full m-0`}
  color: #858591;
`;

export const ManualEntryPromptHint = styled.p`
  ${tw`text-center text-xs w-full m-0 text-neutral-200`}
`;

export const ManualEntryPromptLink = styled.span`
  ${tw`underline cursor-pointer font-medium`}
  color: #666676;
`;

/* Card shown when Google returns no usable result: a bordered, neutral-background
   block that gives the manual-entry path stronger affordance than the inline link. */
export const ManualEntryCard = styled.div`
  ${tw`flex flex-col items-center gap-3 w-full text-center`}
  ${tw`p-6 rounded-2xl border border-neutral-40 bg-neutral-10 shadow-md`}
  animation: ${cardFadeIn} 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ManualEntryCardHeading = styled.p`
  ${tw`text-base font-semibold text-neutral-700 w-full m-0`}
`;

export const ManualEntryCardHint = styled.p`
  ${tw`text-center text-sm w-full m-0 text-neutral-200`}
`;

export const ManualEntryBody = styled.div`
  ${tw`flex flex-col flex-1 w-full items-start`}
  padding: 24px 40px 40px;
  gap: 24px;
`;

export const ManualFieldWrapper = styled.div`
  ${tw`flex flex-col w-full`}
  gap: 8px;
`;

export const ManualFieldLabel = styled.label`
  ${tw`m-0`}
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.21em;
  color: #1c1c33;
`;
